<template>
  <div>
    <list-block>
      <el-form
        ref="formData"
        :inline="true"
        :rules="rules"
        :model="formData"
      >
        <h4 style="margin-bottom: 10px;">
          节点通用设置
        </h4>
        <el-row>
          <el-col :span="9">
            <el-form-item
              label="是否录入封签箱："
              prop="needSealLabel_status"
            >
              <el-radio-group
                v-model="formData.needSealLabel_status"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="item in RETURN_LOCATION_OPTIONS"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="15" style="display: flex;align-items: flex-start;">
            <el-form-item
              label="回库到指定库位："
              prop="returnTemporaryStorehouse"
            >
              <el-radio-group
                v-model="formData.returnStatus"
                :disabled="isDetail"
                @change="getVal"
              >
                <el-radio
                  v-for="item in RETURN_LOCATION_OPTIONS"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-select
              v-if="formData.returnStatus === 'ENABLED'"
              v-model="formData.returnTemporaryStorehouse"
              filterable
              :remote="true"
              reserve-keyword
              placeholder="请选择当前仓库库位"
              style="width: 250px"
              :remote-method="remoteMethod"
              loading-text="加载中……"
              :disabled="isDetail"
            >
              <el-option
                v-for="(item, index) in options"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="9">
            <prescription
              :time.sync="formData.executeMaxTime"
              :time-type.sync="formData.timeUnit"
              :disabled="isDetail"
            />
          </el-col>
        </el-row>
        <TaskSetting
          ref="taskTableEl"
          :node-index="6"
          :table-data="formData.ruleFlowTaskItemDetails"
        />
      </el-form>
    </list-block>
  </div>
</template>

<script>
import ListBlock from '@/components/ListBlock/index.vue';
import { WarehouseLocation } from '@/api/warehouse';
import Prescription from '../../components/Prescription.vue';
import TaskSetting from './TaskSetting.vue';
import { RETURN_LOCATION_OPTIONS, NODE_TYPE } from './constant';

export default {
  components: {
    ListBlock,
    Prescription,
    TaskSetting,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    warehouseCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      RETURN_LOCATION_OPTIONS,
      options: [],
      rules: {
        returnTemporaryStorehouse: [
          { required: false, message: '请选择', trigger: 'change' },
        ],
      },
    };
  },
  watch: {
    warehouseCode: {
      handler(val) {
        if (!val) return;
        this.remoteMethod('', 1, true);
      },
      immediate: true,
    },
  },
  methods: {
    // 纯获取数据
    getPureTableData() {
      return this.$refs.taskTableEl.getPureTableData();
    },
    resetTaskOptions() {
      return this.$refs.taskTableEl.resetTaskOptions();
    },
    getVal(val) {
      if (val !== 'ENABLED') {
        this.options = [];
      }
      this.rules.returnTemporaryStorehouse[0].required = val === 'ENABLED';
      this.$refs.formData.clearValidate();
    },
    remoteMethod(query, num, idRes) {
      if (query || num) {
        const params = {
          warehouseCode: this.warehouseCode,
          page: 1,
          pageSize: 999,
        };
        if (idRes) {
          params.locationIds = [this.formData.returnTemporaryStorehouse];
        } else {
          params.storageLocationCode = query;
        }
        WarehouseLocation(params)
          .then((resp) => {
            resp.records.forEach((item) => {
              this.options.push({
                label: item.storageLocationCode,
                value: item.id,
              });
            });
          })
          .catch(({ resp }) => {
            resp.records.forEach((item) => {
              this.options.push({
                label: item.storageLocationCode,
                value: item.id,
              });
            });
          });
      } else {
        this.options = [];
      }
    },
    validateForm() {
      /* eslint-disable-next-line */
      return new Promise(async (resolve) => {
        try {
          await this.$refs.formData.validate();
          const tableData = await this.$refs.taskTableEl.getTableData(6);
          resolve(tableData);
        } catch (error) {
          this.$message.warning(`请完善“${NODE_TYPE[6].label}”节点数据`);
        }
      });
    },
  },
};
</script>
